module.exports = __webpack_public_path__ + "img/ic_export-error.5690f860.svg";